import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardHeader,Unstable_Grid2 as Grid, Icon, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { TableStats, TableStatsTypes } from "../../../data/interfaces/dashboardmodels";
import dashboardService from "../../../data/api/dashboard.service";
import { useNavigate } from "react-router-dom";

export default function TableCard({type}:{type:TableStatsTypes}){
    const navigate=useNavigate();
    const [header,setHeader]=useState<string>('Magnetic Tables')
    const [icon,setIcon]=useState<string>('credit_card');
    const [stats,setStats]=useState<TableStats>({TotalTableCount:0});
    useEffect(()=>{
        if(type==TableStatsTypes.MagneticTable){
            setHeader("Magnetic Tables");
            setIcon('credit_card')
        }
        else if(type==TableStatsTypes.MagneticOutputTable){
            setHeader("Magnetic Output Tables");
            setIcon('credit_card')
        }else if(type==TableStatsTypes.ITSOTable){
            setHeader("ITSO Tables");
            setIcon('train')
        }else{
            setHeader("ITSO Output Tables");
            setIcon('train')
        }
        dashboardService.getTableStats(type).then((response)=>{
            setStats(response.data);
        })
    },[type]);

    const handleViewMoreClick=()=>{
        if(type==TableStatsTypes.MagneticTable||type==TableStatsTypes.MagneticOutputTable){
            navigate('/magnetic')
        }
        else{
            navigate('/itso')
        }
    }
    return(
        <Card sx={{height:200}} >
            <CardHeader title={header}/>
            <CardContent>
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <Icon sx={{color:'primary.main',fontSize:64}}>{icon}</Icon>
                <Typography sx={{color:'primary.main'}} variant="h2">{stats.TotalTableCount}</Typography>
                </Box>
                
            </CardContent>
            <CardActionArea sx={{textAlign:'center',color:'primary.main'}} onClick={handleViewMoreClick}>
                <Typography variant="body1">View More</Typography> 
            </CardActionArea>
        </Card>
    )
}